"use client";

import { createIcon } from "@chakra-ui/react";

const MinusSvgIcon = createIcon({
  displayName: "MinusSvgIcon",
  viewBox: "0 0 16 16",
  path: (
    <path xmlns="http://www.w3.org/2000/svg" d="M2.06641 7.99805L13.9291 7.99915" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel"/>
  ),
});

export default MinusSvgIcon;
